<div class="dialog-wrapper">
    <div class="d-flex justify-content-between mb-3 align-items-center">
        <h3>
            <mat-icon svgIcon="{{ data.icon }}" *ngIf="data.icon != null"></mat-icon>
            {{ data.title | translate }}
        </h3>
        <button mat-icon-button (click)="onNoClick()">
            <mat-icon class="red-400">close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content>
        <span innerHtml="{{ data.text | translate }}"></span>
        <mat-form-field appearance="outline" *ngIf="data.type == 'prompt'">
            <input type="text" matInput>
        </mat-form-field>
    </div>
    <div mat-dialog-actions class='pb-3'>
        <div style="width: 100%; text-align: center">
            <div *ngIf="data.type == 'prompt'">
                <button mat-raised-button color="primary" (click)="onClick()">
                    <mat-icon>arrow_right</mat-icon>
                    <span>Valider</span>
                </button>
                <button mat-stroked-button color="primary" (click)="onNoClick()">
                    <mat-icon>arrow_right</mat-icon>
                    <span>Annuler</span>
                </button>
            </div>
            <div *ngIf="data.type == 'confirm'" class="text-right block-confirm">
                <br/>
                <button mat-button color="primary" class="gray-800" (click)="onNoClick()">
                    <mat-icon>arrow_right</mat-icon>
                    <span>{{ 'general_labels.cancel' | translate }}</span>
                </button>
                <button cdkFocusInitial mat-button color="primary" (click)="onClick()">
                    <mat-icon>arrow_right</mat-icon>
                    <span>{{ 'general_labels.confirm' | translate }}</span>
                </button>
            </div>
            <div *ngIf="data.type == 'alert'">
                <br/>
                <button mat-raised-button color="primary" (click)="onClick()">
                    <mat-icon>arrow_right</mat-icon>
                    <span>OK</span>
                </button>
            </div>
        </div>
    </div>
</div>